module.exports = __webpack_public_path__ + "img/box-zi.61dee814.png";